import * as React from 'react';
import {
  Tabs,
  Icon,
  Skeleton,
  Spin,
  Popconfirm,
  notification,
  Button,
  Modal,
  Tag,
} from 'antd';
import { Table } from '../common/Table';
import { CompanyService } from '../../service/CompanyService';
import { CompanyNodeEdge } from '../master/Company/constants';
import { GraphqlQuery } from 'requestapijs';
import { Pagination } from 'sha-el-design';
import {
  PurchaseOrderNode,
  PurchaseOrderNodeConnection,
  PurchaseOrderNodeEdge,
} from '../../schema';
import { purchaseOrderQuery } from './constants';
import { AddPurchaseOrder } from './AddPurchaseOrder';
import moment from 'moment';
import { PurchaseOrderReceiptJharcraft } from './PurchaseOrderReceiptJharcraft';
import { PurchaseOrderReceiptHindgroup } from './PurchaseOrderReceiptHindgroup';
import { PDFViewer } from '@react-pdf/renderer';
import { UserService } from '../../service/UserService';
import { UserNodeEdge } from '../../components/user/constants';
import { checkAddPermission } from '../helper';
import { PurchaseOrderService } from '../../service/PurchaseOrderService';
import { PurchaseOrderReceiptKhadi } from './PurchaseOderReceiptKhadi';
import { ProductDetails as PurchaseOrderProductDetails } from './constants';

export class PurchaseOrder extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: '1',
      selectedPurchaseOrder: null,
      company: null,
      currentPage: 1,
      after: '',
      user: null,
      updateListCount: 0,
      cancelItemsPurchaseOrder: null,
    };
  }

  companyService = new CompanyService();
  userService = new UserService();
  purchaseOrderService = new PurchaseOrderService();

  componentDidMount() {
    this.companyService?.company$.subscribe((company) =>
      this.setState({ company }),
    );
    this.userService?.user$.subscribe((user) =>
      this.setState({ user: user?.user }),
    );
  }

  handleTabChange = (activeKey: string) => {
    if (activeKey === '1') {
      this.setState({ activeKey, selectedPurchaseOrder: null });
      this.componentDidMount();
      return;
    }
    this.setState({ activeKey });
  };

  purchaseOrderColumn = () => [
    {
      title: 'Date Ordered on',
      dataIndex: 'node.date',
      key: 'date',
      render: (text) => moment(text).format('DD-MM-YYYY'),
    },
    {
      title: 'Purchase Order No',
      dataIndex: 'node.purchaseOrderNo',
      key: 'purchaseOrderNo',
      render: (text, obj) => (
        <a
          onClick={() => {
            this.setState({ selectedPurchaseOrder: obj.node, activeKey: '2' });
          }}
        >
          {text}
        </a>
      ),
      sortingValue: (text) => text,
    },
    {
      title: 'Vendor',
      dataIndex: 'node.vendor.name',
      key: 'vendor',
    },
    {
      title: 'Receipt',
      key: 'receipt',
      render: (text, record) => (
        <a
          onClick={() => {
            this.setState({
              selectedPurchaseOrder: record.node,
              activeKey: '3',
            });
          }}
        >
          <Icon type="download" />
        </a>
      ),
    },
    {
      title: 'Cancel',
      key: 'cancel',
      render: (text: PurchaseOrderNodeEdge) => (
        <Popconfirm
          title="Are you sure to Cancel?"
          onConfirm={() =>
            text.node?.id &&
            this.purchaseOrderService?.cancelPurchaseOrder(text.node.id, () => {
              this.setState({
                updateListCount: this.state.updateListCount + 1,
              });
              notification.success({
                message: 'Cancelled',
                description: `Purchase Order was successfully cancelled`,
              });
            })
          }
          okText="Yes"
          cancelText="No"
          disabled={
            text.node?.isCancel ||
            (!!this.state.user && !checkAddPermission(this.state.user))
          }
        >
          <Button
            children={<Icon type="delete" />}
            type="danger"
            disabled={
              text.node?.isCancel ||
              (!!this.state.user && !checkAddPermission(this.state.user))
            }
          />
        </Popconfirm>
      ),
    },
    {
      title: 'Cancel Items',
      key: 'cancelItems',
      render: (text: PurchaseOrderNodeEdge) => (
        <Button
          size="small"
          onClick={() =>
            text.node && this.setState({ cancelItemsPurchaseOrder: text.node })
          }
          disabled={
            !text.node ||
            text.node.isCancel ||
            (!!this.state.user && !checkAddPermission(this.state.user))
          }
        >
          Cancel Items
        </Button>
      ),
    },
  ];

  getPurchaseOrderItems = (purchaseOrder: PurchaseOrderNode) => {
    const productDetails =
      purchaseOrder.productDetailsWithAvailbleQty?.productDetails ||
      purchaseOrder.productDetails;
    return JSON.parse(productDetails) as PurchaseOrderProductDetails[];
  };

  cancelPurchaseOrderItem = (productIndex: number) => {
    const purchaseOrder = this.state.cancelItemsPurchaseOrder;
    if (!purchaseOrder) return;

    this.purchaseOrderService.cancelPurchaseOrderItem(
      purchaseOrder.id,
      productIndex,
      (response) => {
        const updatedPurchaseOrder =
          response.data.cancelPurchaseOrderItem.purchaseOrder;
        this.setState({
          cancelItemsPurchaseOrder: updatedPurchaseOrder,
          updateListCount: this.state.updateListCount + 1,
        });
        notification.success({
          message: 'Item Cancelled',
          description: 'The purchase order item was successfully cancelled.',
        });
      },
      (error) =>
        notification.error({
          message: 'Item Cancellation Failed',
          description: JSON.stringify(error),
        }),
    );
  };

  afterStack = [''];

  onPageChange = (next: boolean, after: string, nextPage: boolean) => {
    if (next && nextPage) {
      this.setState({ after, currentPage: this.state.currentPage + 1 });
      this.afterStack.push(after);
    } else if (!next && this.afterStack.length > 1) {
      this.afterStack.pop();
      this.setState({
        after: this.afterStack[this.afterStack.length - 1],
        currentPage: this.state.currentPage - 1,
      });
    }
  };

  render() {
    if (!this.state.company) {
      return <Skeleton active />;
    }

    const {
      company: { id: companyId },
      after,
      currentPage,
      activeKey,
      updateListCount,
    } = this.state;
    return (
      <div>
        <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange}>
          <Tabs.TabPane
            tab={
              <span>
                <Icon type="table" />
                List Purchase Order
              </span>
            }
            key="1"
            closable={false}
          >
            <GraphqlQuery
              queryString={purchaseOrderQuery}
              variables={{
                companyId,
                first: 20,
                after,
                activeKey,
                updateListCount,
              }}
              render={(
                response: { allPurchaseOrders: PurchaseOrderNodeConnection },
                error,
                loading,
              ) => {
                if (loading) return <Spin />;
                if (error) return <h3>Something Went Wrong!!</h3>;
                if (response && companyId) {
                  return [
                    <Table
                      key="table"
                      dataSource={response.allPurchaseOrders.edges}
                      columns={this.purchaseOrderColumn()}
                      rowKey={(obj) => obj.node?.id || ''}
                      pagination={false}
                    />,
                    <Pagination
                      key="pagination"
                      totalCount={0}
                      currentPage={currentPage}
                      batchSize={20}
                      cursorBasedPagination
                      onChange={(_p, _ps, next) =>
                        this.onPageChange(
                          next,
                          response.allPurchaseOrders.pageInfo.endCursor,
                          response.allPurchaseOrders.pageInfo.hasNextPage,
                        )
                      }
                      style={{ float: 'right' }}
                    />,
                  ];
                }
                return <Skeleton active />;
              }}
            />
          </Tabs.TabPane>
          {this.state.user && checkAddPermission(this.state.user) && (
            <Tabs.TabPane
              tab={
                <span>
                  <Icon type="plus" />
                  Add Purchase Order
                </span>
              }
              key="2"
            >
              <AddPurchaseOrder
                purchaseOrder={this.state.selectedPurchaseOrder}
                handleTabChange={this.handleTabChange}
                company={this.state.company}
              />
            </Tabs.TabPane>
          )}
          {this.state.selectedPurchaseOrder && this.state.activeKey === '3' && (
            <Tabs.TabPane
              tab={
                <span>
                  <Icon type="file" />
                  Receipt
                </span>
              }
              key="3"
            >
              <PDFViewer style={{ width: '100%', height: '1000px' }}>
                {this.state.company.name.toLowerCase().includes('tiles') ? (
                  <PurchaseOrderReceiptHindgroup
                    purchaseOrder={this.state.selectedPurchaseOrder}
                    company={this.state.company}
                  />
                ) : this.state.company.name.toLowerCase().includes('khadi') ? (
                  <PurchaseOrderReceiptKhadi
                    purchaseOrder={this.state.selectedPurchaseOrder}
                    company={this.state.company}
                  />
                ) : (
                  <PurchaseOrderReceiptJharcraft
                    purchaseOrder={this.state.selectedPurchaseOrder}
                    company={this.state.company}
                  />
                )}
              </PDFViewer>
            </Tabs.TabPane>
          )}
        </Tabs>
        <Modal
          title={`Cancel items for ${
            this.state.cancelItemsPurchaseOrder?.purchaseOrderNo || ''
          }`}
          visible={!!this.state.cancelItemsPurchaseOrder}
          onCancel={() => this.setState({ cancelItemsPurchaseOrder: null })}
          footer={[
            <Button
              key="close"
              onClick={() => this.setState({ cancelItemsPurchaseOrder: null })}
            >
              Close
            </Button>,
          ]}
        >
          {this.state.cancelItemsPurchaseOrder &&
            this.getPurchaseOrderItems(this.state.cancelItemsPurchaseOrder).map(
              (item, index) => {
                const receivedQuantity = Number(item.availableQuantity || 0);
                const cancelledQuantity = Number(item.cancelledQuantity || 0);
                const quantity = Number(item.quantity || 0);
                return (
                  <div
                    key={`${item.productName}-${index}`}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '8px 0',
                      borderBottom: '1px solid #f0f0f0',
                    }}
                  >
                    <span>
                      {item.productName} ({quantity} {item.unit})
                    </span>
                    {cancelledQuantity >= quantity ? (
                      <Tag color="red">Cancelled</Tag>
                    ) : receivedQuantity > 0 ? (
                      <Tag color="orange">
                        Received (cannot cancel): {receivedQuantity}
                      </Tag>
                    ) : (
                      <Popconfirm
                        title={`Cancel ${item.productName}?`}
                        onConfirm={() => this.cancelPurchaseOrderItem(index)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button size="small" type="danger">
                          Cancel item
                        </Button>
                      </Popconfirm>
                    )}
                  </div>
                );
              },
            )}
        </Modal>
      </div>
    );
  }
}

interface State {
  activeKey: string;
  selectedPurchaseOrder: PurchaseOrderNode | null;
  company: CompanyNodeEdge | null;
  after: string;
  currentPage: number;
  user?: UserNodeEdge | null;
  updateListCount: number;
  cancelItemsPurchaseOrder: PurchaseOrderNode | null;
}

interface Props {}
